exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:768px){div#sticky-wrapper .side_wrap[data-v-8e4e5c3c]::-webkit-scrollbar{display:none}div#sticky-wrapper.is-sticky .side_wrap[data-v-51cb8b16][data-v-8e4e5c3c]{height:-moz-calc(100vh - 185px);height:calc(100vh - 185px);overflow-y:scroll}}", ""]);

// exports
